import LegalLayout from "@/pages/LegalLayout";

const SECTIONS = [
  {
    heading: "Agreement between User and peachflowai.com",
    paragraphs: [
      "Welcome to https://peachflowai.com/. The https://peachflowai.com/ website (\"Site\") is comprised of various web pages operated by PeachFlow AI.",
      "The Site is offered to you conditioned upon your acceptance without modification of the terms, conditions, and notices contained herein (\"Terms\").",
      "Your use of the Site constitutes your agreement to all such Terms.",
      "Please read these Terms carefully and keep a copy for your records.",
    ],
  },
  {
    heading: "Purpose of the Website",
    paragraphs: [
      "PeachFlowAI.com is a technology services website that provides information about our AI automation solutions, software development services, consulting, and digital tools designed to help businesses improve efficiency, automate workflows, and enhance operations.",
      "The website also allows visitors to:",
    ],
    list: [
      "Learn about our services",
      "Request consultations",
      "Contact our team",
      "Access educational content related to artificial intelligence, automation, and business technology",
    ],
  },
  {
    heading: "Electronic Communications",
    paragraphs: [
      "By visiting PeachFlowAI.com or sending emails to PeachFlow AI, you consent to receive electronic communications.",
      "You agree that agreements, notices, disclosures, and other communications we provide electronically satisfy any legal requirement that such communications be in writing.",
    ],
  },
  {
    heading: "Children Under Thirteen",
    paragraphs: [
      "PeachFlow AI does not knowingly collect personal information from children under 13 years of age.",
    ],
  },
  {
    heading: "Cancellation & Refund Policy",
    subsections: [
      {
        sub: "Project Deposits",
        paragraphs: [
          "All project deposits, implementation fees, and setup fees are non-refundable.",
          "Once a project begins, PeachFlow allocates time and resources specifically to your business.",
        ],
      },
      {
        sub: "Before Work Begins",
        paragraphs: [
          "If a client cancels before work has started, PeachFlow may, at its sole discretion, issue a partial refund minus any administrative, consultation, or planning costs already incurred.",
        ],
      },
      {
        sub: "After Work Begins",
        paragraphs: [
          "Once development, implementation, configuration, or integration has started, no refunds will be issued for setup or implementation fees.",
        ],
      },
      {
        sub: "Monthly Subscription",
        paragraphs: [
          "Monthly support plans may be canceled with 30 days' written notice.",
          "Services continue through the end of the current billing period.",
          "No partial or prorated refunds are provided unless required by law.",
        ],
      },
      {
        sub: "Custom Development",
        paragraphs: [
          "Because every AI solution is custom-built, all custom software, automations, workflows, prompts, integrations, and consulting services are considered personalized services and are not eligible for refunds once work has begun.",
        ],
      },
      {
        sub: "Client Delays",
        paragraphs: [
          "If a client fails to provide requested information, approvals, or access for more than 30 consecutive days, the project may be placed on hold.",
          "Projects inactive for more than 60 days may require a restart fee before work resumes.",
        ],
      },
      {
        sub: "Chargebacks",
        paragraphs: [
          "If a client initiates a chargeback without first contacting PeachFlow to resolve the issue, PeachFlow reserves the right to suspend all services until the matter is resolved.",
        ],
      },
      {
        sub: "Exceptions",
        paragraphs: [
          "If PeachFlow determines that it cannot deliver the agreed-upon services due to reasons within its control, it may provide a full or partial refund at its sole discretion.",
        ],
      },
    ],
  },
  {
    heading: "Links to Third-Party Sites",
    paragraphs: [
      "The Site may contain links to third-party websites.",
      "PeachFlow AI is not responsible for the content or operation of third-party websites.",
    ],
  },
  {
    heading: "Third-Party Services",
    paragraphs: [
      "Some services available through PeachFlowAI.com may be delivered by third-party providers.",
      "By using those services, you acknowledge that PeachFlow AI may share necessary information with those providers to deliver requested services.",
    ],
  },
  {
    heading: "Intellectual Property",
    paragraphs: [
      "All content on the Site—including text, graphics, logos, images, software, and design—is owned by PeachFlow AI or its licensors and protected by intellectual property laws.",
      "Without our permission, you may not:",
    ],
    list: ["Copy", "Modify", "Republish", "Sell", "Reverse engineer", "Create derivative works"],
  },
  {
    heading: "International Users",
    paragraphs: [
      "Users accessing the Site outside the United States are responsible for complying with local laws.",
    ],
  },
  {
    heading: "Indemnification",
    paragraphs: [
      "Users agree to defend and hold PeachFlow AI harmless from claims, liabilities, damages, and expenses arising from misuse of the Site or violation of these Terms.",
    ],
  },
  {
    heading: "Arbitration",
    paragraphs: [
      "Disputes will be resolved through binding arbitration rather than court litigation, except where prohibited by law.",
    ],
  },
  {
    heading: "Class Action Waiver",
    paragraphs: [
      "Users agree that disputes will be brought only on an individual basis and not as part of a class action or representative proceeding.",
    ],
  },
  {
    heading: "Disclaimer of Liability",
    paragraphs: [
      "Information, products, and services are provided \"AS IS\" without warranties of any kind.",
      "PeachFlow AI disclaims implied warranties including:",
    ],
    list: ["Merchantability", "Fitness for a particular purpose", "Non-infringement"],
  },
  {
    heading: "Limitation of Liability",
    paragraphs: ["To the fullest extent permitted by law, PeachFlow AI is not liable for:"],
    list: [
      "Indirect damages",
      "Incidental damages",
      "Consequential damages",
      "Lost profits",
      "Lost data",
      "Business interruption",
    ],
  },
  {
    heading: "Termination",
    paragraphs: [
      "PeachFlow AI reserves the right to terminate or suspend access to the Site at any time without notice.",
    ],
  },
  {
    heading: "Governing Law",
    paragraphs: ["These Terms are governed by the laws of the State of Texas."],
  },
  {
    heading: "Entire Agreement",
    paragraphs: [
      "These Terms constitute the complete agreement between the user and PeachFlow AI regarding use of the Site.",
    ],
  },
  {
    heading: "Changes to Terms",
    paragraphs: [
      "PeachFlow AI may modify these Terms at any time.",
      "Continued use of the Site constitutes acceptance of any revised Terms.",
    ],
  },
  {
    heading: "Contact Information",
    paragraphs: ["Email: hello@peachflowai.com"],
  },
];

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      title="Website Terms and Conditions"
      updated="July 2026"
      intro="These Terms and Conditions govern your use of PeachFlowAI.com. By using the Site, you agree to them in full."
      sections={SECTIONS}
    />
  );
}
